import { IReportConfiguration } from '@opengov/reporting-types';

import { reportConfigurationEffects } from './effects/reportConfigurationEffects';

// The current config id is nulled on every edit (dirty marker) and only repopulated once
// persisted. Persist unsaved edits (e.g. hidden columns) here so create/update saved view
// links to a config that reflects them. See BUD-17949 / CRD-13088.
export const resolveReportConfigurationId = async (
  reportConfiguration: IReportConfiguration,
  fallbackReportConfigurationId?: string
): Promise<string | undefined> => {
  if (reportConfiguration.id) {
    return reportConfiguration.id;
  }
  if (fallbackReportConfigurationId) {
    return fallbackReportConfigurationId;
  }
  // reportConfigurationEffects is loosely typed (any) at this import boundary; narrow the
  // one method we use so the persisted config (and its id) stay strongly typed.
  const persistReportConfiguration = (
    reportConfigurationEffects as { createReportConfiguration: () => Promise<IReportConfiguration> }
  ).createReportConfiguration;
  const persistedReportConfiguration = await persistReportConfiguration();
  return persistedReportConfiguration.id;
};
